import React, { useEffect, useRef, useState } from "react";
import "./BackgroundSection.css";
import Aboutimg from "../Assets/Cm-About-img.jpeg";
import { useTranslation } from "react-i18next";

// COUNT UP COMPONENT
function CountUp({ end, duration = 2000 }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;

          let start = 0;
          const stepTime = Math.abs(Math.floor(duration / end));

          const timer = setInterval(() => {
            start += 1;
            setCount(start);
            if (start >= end) clearInterval(timer);
          }, stepTime);
        }
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, [end, duration]);

  return <span ref={ref}>{count}+</span>;
}

export default function BackgroundSection() {
  const { t } = useTranslation();

  return (
    <section className="bgSection_wrapper">
      <div className="bgSection_container">

        {/* LEFT CONTENT */}
        <div className="bgSection_leftBox">
          <h4 className="bgSection_smallTitle">{t("leader_small_title")}</h4>

          <h2 className="bgSection_mainTitle">
            {t("leader_main_title")}
          </h2>

          <p className="bgSection_description">
            {t("leader_description")}
          </p>

          <ul className="bgSection_list">
            <li>{t("leader_list_1")}</li>
            <li>{t("leader_list_2")}</li>
            <li>{t("leader_list_3")}</li>
          </ul>

          <a href="/about-cmpranesh">
            <button className="bgSection_readMoreBtn">
              {t("leader_read_more")}
            </button>
          </a>
        </div>

        {/* RIGHT IMAGE + STATS */}
        <div className="bgSection_rightBox">
          <img 
            src={Aboutimg} 
            alt="aboutSection" 
            className="bgSection_image"
          />

          <div className="bgSection_statsRow">
            
            <div className="bgSection_statCard">
              <h3><CountUp end={500} /></h3>
              <p>{t("stat_students")}</p>
            </div>

            <div className="bgSection_statCard">
              <h3><CountUp end={550} /></h3>
              <p>{t("stat_women")}</p>
            </div>

            <div className="bgSection_statCard">
              <h3><CountUp end={450} /></h3>
              <p>{t("stat_patients")}</p>
            </div>

            <div className="bgSection_statCard">
              <h3><CountUp end={350} /></h3>
              <p>{t("stat_handicaps")}</p>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}
